import store from '@/store';

import { createWebHistory, createRouter } from 'vue-router';

const routes = [
    { path: '/', redirect: { name: 'signIn' } },
    { path: '/signIn', name: 'signIn', component: () => import('../page/Login/view/LoginView.vue') },
    { path: '/registration', name: 'registration', component: () => import('../page/Registration/view/RegistrationView.vue'), meta:{reqAuth:true},
    children:[
        { path: ':id', component: () => import('../page/Registration/view/RegistrationView.vue'), meta:{reqAuth:true} },

    ] },
    {
        path: '/findRegistration', name: 'findRegistration', component: () => import('@/page/ListRegistration/view/ListView.vue'), redirect: {name:'list'},meta:{reqAuth:true} ,
        children:[
            {path: '', name: 'list', component: () => import('@/page/ListRegistration/children/page/ListRegistrationView.vue'), props: true },
            { path: 'full/:id', name: 'full', component: () => import('@/page/ListRegistration/children/page/FullOpenRegistrationView.vue'), props: true },
        ]
    },
    { path: '/panelAdmin', name: 'panelAdmin', component: () => import('@/page/AdminPanel/view/AdminPanelView.vue'),meta:{reqAuth:true} , children:[
       
    ] },
    {path:'/configUser', name:'configUser', component:()=>import('@/page/ConfigUser/view/ConfigUserView.vue'),meta:{reqAuth:true} },
    { path: '/:pathMatch(.*)*', redirect: { name: 'signIn' } },
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach((to,from, next)=>{
    const auth = store.getters.getAuth;
    if(to.matched.some(record=>record.meta.reqAuth)){
        if(!auth){
            next({
                path:'/signIn',
                query: {redirect:to.fullPath}
            })
        }else{
            next()
        }
    }else if(to.path==='/signIn' && auth){
        next({
            path:'/findRegistration'
        });
    }else{
        next()
    }
})
export default router